export default "__VITE_ASSET__9b050b00__"